<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore, getHrefForMediaItem } from '../../../utilities';
import { Readable } from 'svelte/store';
import ActionButton from "../ActionButton/ActionButton.svelte";
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { CardsPageContext, CardsPageContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import { resolveUrl } from '../../../../../js/url';
import { JanusSignonManagerToken, SSOResult } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { ycSSOSetState } from '../../../../../js/ycapp';
import { f7 } from 'framework7-svelte';
import { t } from "../../../../../js/i18n";
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
const pageContext = getContext(CardsPageContextKey);
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: mergedParams = (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store;
$: passwordKey = (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.passwordKey;
$: emailKey = (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.emailKey;
$: phoneKey = (_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.phoneKey;
$: rememberMeKey = (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.rememberMeKey;
$: resultKey = (_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.resultKey;
$: useDjangoLogin = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.useDjangoLogin) || false;
$: useCognitoLogin = ((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.useCognitoLogin) || false;
$: cognitoUsernameType = ((_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.cognitoUsernameType) || 'EMAIL';
$: dismissAfterLogin = ((_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k.dismissAfterLogin) || false;
$: nextPageUrl = ((_l = element === null || element === void 0 ? void 0 : element.data) === null || _l === void 0 ? void 0 : _l.nextPageUrl) || null;
$: useSportsAllianceLogin = ((_m = element === null || element === void 0 ? void 0 : element.data) === null || _m === void 0 ? void 0 : _m.useSportsAllianceLogin) || false;
$: isEmailValid = (_o = element === null || element === void 0 ? void 0 : element.data) === null || _o === void 0 ? void 0 : _o.isEmailValid;
$: isPasswordValid = (_p = element === null || element === void 0 ? void 0 : element.data) === null || _p === void 0 ? void 0 : _p.isPasswordValid;
$: email = emailKey ? ($mergedParams || {})[emailKey] : '';
$: phone = phoneKey ? ($mergedParams || {})[phoneKey] : '';
$: password = passwordKey ? ($mergedParams || {})[passwordKey] : '';
$: isRememberMe = rememberMeKey ? ($mergedParams || {})[rememberMeKey] : '';
$: isValidEmail = isEmailValid ? ($mergedParams || {})[isEmailValid] : '';
$: isValidPassword = isPasswordValid ? ($mergedParams || {})[isPasswordValid] : '';
$: console.log('account_login: ', email, phone, password, isValidEmail, isValidPassword, isRememberMe);
$: isValid = (useCognitoLogin && cognitoUsernameType === 'PHONE') ?
    !!(phone && password && isValidPassword === "true") :
    !!(email && password && isValidEmail === "true" && isValidPassword === "true");
const handleClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
    var _q;
    f7.preloader.show();
    try {
        console.log('AccountLogInButton: ', email, phone, password, isRememberMe);
        tabContext.setParam(resultKey, "false");
        let result = { success: false };
        if (useDjangoLogin) {
            result = yield signonManager.loginWithDjangoEmailPassword(email, password);
        }
        else if (useCognitoLogin) {
            const phone_number = `+${phone}`; // Cognito requires phone numbers to be prefixed with +
            result = yield signonManager.loginWithCognitoUsernamePassword((cognitoUsernameType === 'PHONE') ? phone_number : email, password);
        }
        else if (useSportsAllianceLogin) {
            result = yield signonManager.loginWithSportsAllianceUserPassword(email, password);
        }
        else {
            result = yield signonManager.loginWithYinzCamUserPassword(email, password);
        }
        console.log('SSO: login result', result);
        if (result.success) {
            ycSSOSetState(result.data.AccountCreated === 'true', result.data.YinzId, parseInt(result.data.ValidSpan), result.data.Ticket);
            // TODO: Determine if user needs to complete profile?
            // resolveUrl(`CompleteProfile?firstName=${firstName}&lastName=${lastName}&email=${email}`).func();
            // resolveUrl(`ConnectAccounts`).func();
            const ssoRedirectAfterLogin = window.localStorage.getItem('ssoRedirectAfterLogin');
            window.localStorage.removeItem('ssoRedirectAfterLogin');
            if (dismissAfterLogin) {
                signonManager.fireWorkflowEndEvent();
            }
            else if (ssoRedirectAfterLogin) {
                setTimeout(() => {
                    window.location.href = ssoRedirectAfterLogin;
                }, 1000);
            }
            else if (nextPageUrl) {
                resolveUrl(nextPageUrl).func();
            }
            else if (signonManager.skipCompleteProfilePage) {
                resolveUrl(`ConnectAccounts`).func();
            }
            else {
                resolveUrl(`CompleteProfile`).func();
            }
        }
        else {
            alert(((_q = result.errorMessage) === null || _q === void 0 ? void 0 : _q.description) || 'An error occurred.');
        }
    }
    finally {
        f7.preloader.hide();
    }
});
</script>
<CardBase {element}>
  <ActionButton onClick={handleClick} disabled={!isValid} title={$t("Log in")}/>
</CardBase>

